import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-managemembers',
    templateUrl: './managemembers.component.html',
    styleUrls: ['./managemembers.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageMembersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
